

export interface IPitchValue {
    time?: number;
    sampleTime?: number;
    pitch: number;
    power?: number;
}


export interface IPitchFilter {

    processSample(value: IPitchValue): IPitchValue;

    readonly rawData: IPitchValue[];
} 


export function emptyPitch(value: IPitchValue) {
    return { ...value, pitch: undefined } as IPitchValue;
}